import React, { FC, useEffect } from 'react';

import Modal from '~components/atoms/Modal';

import CreateGoldConversionForm from '../CreateGoldConversionForm';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import GoldConversionSummary from '../GoldConversionForm';
import combinedActions from '~redux/combinedActions';

type GoldConversionModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

const GoldConversionModal: FC<GoldConversionModalProps> = ({
    isOpen,
    onClose,
}) => {
    const dispatch = useAppDispatch();

    const isFormFilled = useAppSelector((state) => state.gold.modals.isFormFilled);

    useEffect(() => {
        if (!isOpen) {
            dispatch(combinedActions.goldClearInventoryFilterParams());
            dispatch(combinedActions.customerResetCustomerState());
            dispatch(combinedActions.goldGetAllInventoriesAttempt());
            dispatch(combinedActions.customerResetCustomerInventory());
            dispatch(combinedActions.goldResetGoldConversionAmount());
            dispatch(combinedActions.goldResetGoldConversionDraftsFee());
            dispatch(combinedActions.goldClearConversionDraftsFee());
            dispatch(combinedActions.goldResetGoldConversionFinalDrafts());
            dispatch(combinedActions.goldSetIsFormFilled(false));
        }
    }, [isOpen, dispatch]);

    const renderContent = () => {
        if (isFormFilled) {
            return <GoldConversionSummary />;
        }

        return <CreateGoldConversionForm />;
    };

    return (
        <Modal
            testId='conversion-create-close-modal'
            isOpen={isOpen}
            onClose={onClose}
            title='Create Conversion'
        >
            {/* <CreateGoldConversionForm /> */}
            {renderContent()}
        </Modal>
    );
};

export default GoldConversionModal;
